export const PRODUCT_INVENTORY_REQUEST = 'productInventories/actions/request';
export const PRODUCT_INVENTORY_SUCCESS = 'productInventories/actions/success';
export const PRODUCT_INVENTORY_FAILURE = 'productInventories/actions/failure';

export const PRODUCT_DETAILS_REQUEST = 'productInventories/actions/details/request';
export const PRODUCT_DETAILS_SUCCESS = 'productInventories/actions/details/success';
export const PRODUCT_DETAILS_FAILURE = 'productInventories/actions/details/failure';

export const PRODUCT_FILTERS_SUCCESS = 'productInventories/actions/filters/success';
export const PRODUCT_FILTERS_FAILURE = 'productInventories/actions/filters/failure';

export const PRODUCT_SET_FILTERS_SUCCESS = 'productInventories/actions/set-filters/success';
export const PRODUCT_SET_FILTERS_CLEAR = 'productInventories/actions/set-filters/clear';
export const PRODUCT_SET_GLOBAL_INACTIVE_FILTER_SUCCESS = 'productInventories/actions/set-filter/inactive/success';

export const PRODUCT_SET_SEARCH_QUERY = 'productInventories/actions/set-search-query';

export const PRODUCT_GROUP_BY = 'productInventories/actions/group-by';

export const PRODUCT_SET_INACTIVE_REQUEST = 'productInventories/setInactive/request';
export const PRODUCT_SET_INACTIVE_SUCCESS = 'productInventories/setInactive/success';
export const PRODUCT_SET_INACTIVE_FAILURE = 'productInventories/setInactive/failure';

export const PRODUCT_INVENTORY_STATS_SUCCESS = 'productInventories-stats/actions/success';
export const PRODUCT_INVENTORY_STATS_FAILURE = 'productInventories-stats/actions/failure';

export const PRODUCT_INVENTORY_EXPORT_SUCCESS = 'productInventories/actions/export/success';
export const PRODUCT_INVENTORY_EXPORT_FAILURE = 'productInventories/actions/export/failure';
export const RESET_EXPORT_FILE_URL = 'productInventories/actions/reset-export-file-url';

export const UPDATE_SPECIALTY_USE_VALUE_SUCCESS = 'productInventories/actions/update-specialty-use-value/success';
export const UPDATE_SPECIALTY_USE_VALUE_ERROR = 'productInventories/actions/update-specialty-use-value/error';
